import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import Reveal from "@/components/Reveal";
import Newsletter from "@/components/Newsletter";

const EXISTS = [
  "What should I cook?",
  "What should I wear?",
  "What should I buy?",
  "What should I clean?",
  "What should I use for my skin?",
];

export default function Vision() {
  return (
    <div data-testid="vision-page" className="pt-32">
      <section className="relative overflow-hidden py-16 md:py-24">
        <div className="mesh-bg">
          <div className="mesh-blob" style={{ width: 460, height: 460, background: "#F28C82", top: -100, right: -60 }} />
          <div className="mesh-blob" style={{ width: 400, height: 400, background: "#B8E3D9", bottom: -80, left: -80 }} />
        </div>
        <div className="relative z-10 mx-auto max-w-4xl px-6 text-center md:px-12">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#F28C82]">Vision</p>
            <h1 className="mt-6 font-heading text-4xl font-light leading-tight tracking-tighter text-[#4B2E5A] md:text-6xl">
              We're not building apps.
            </h1>
            <h1 className="mt-2 font-heading text-4xl font-light leading-tight tracking-tighter text-[#F28C82] md:text-6xl">
              We're building the operating system for everyday life.
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="py-12 md:py-20">
        <div className="mx-auto max-w-4xl px-6 md:px-12">
          <Reveal className="glass rounded-[24px] p-8 md:p-14">
            <h2 className="font-heading text-2xl font-medium text-[#4B2E5A] md:text-3xl">Why we exist</h2>
            <p className="mt-4 text-lg leading-relaxed text-[#4B2E5A]/70">Every day people ask:</p>
            <div className="mt-6 space-y-4">
              {EXISTS.map((q) => (
                <div key={q} className="flex items-center gap-3">
                  <CheckCircle2 className="h-5 w-5 shrink-0 text-[#B8E3D9]" />
                  <span className="text-lg text-[#4B2E5A]/80">{q}</span>
                </div>
              ))}
            </div>
            <p className="mt-8 text-lg leading-relaxed text-[#4B2E5A]/70">
              We're building intelligent products that answer those questions — removing the decision fatigue that quietly shapes every day.
            </p>
          </Reveal>

          <Reveal delay={0.1} className="mt-10 text-center">
            <Link to="/products" data-testid="vision-explore-btn" className="inline-flex items-center gap-2 rounded-full bg-[#4B2E5A] px-8 py-4 text-sm font-medium text-[#FCFAF7] hover:bg-[#4B2E5A]/90">
              Explore our products <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
      <Newsletter />
    </div>
  );
}
